module.exports = __webpack_public_path__ + "2ffc0d5a3832fde7bc9a2c57543af204.pdf";